<template>
  <el-container
    id="pagar-container"
    style="justify-content: center; align-items: center"
    v-loading.fullscreen.lock="loading"
  >
    <!-- <el-header /> -->
    <el-main>
      <el-col
        :xs="24"
        :sm="20"
        :md="15"
        :lg="10"
      >
        <el-row type="flex" justify="end">
          <el-col :xs="24" :sm="5">
            <el-button
              type="primary" @click="$goBack()"
              style="width: 100%"
            >
              Volver
            </el-button>
          </el-col>
        </el-row>

        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-position="top"
          @keydown.enter.native="submit"
          @submit.prevent.native
          @submit="submit"
          :disabled="loading"
          label-suffix=":"
          style="padding: 10px 15px"
        >
          <el-row gutter="5">
            <el-col :xs="24" :sm="24">
              <!-- :md="12" -->
              <el-form-item label="Tipo de pago" prop="promocion">
                <el-radio-group
                  v-model="form.promocion"
                  style="width: 100%; margin-bottom: 15px"
                  class="flex xs-display-block-childs"
                >
                  <el-radio
                    v-for="item in paymentMethods"
                    :key="item.value"
                    :label="item.value"
                  >
                    {{ item.label }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <br>
            <br>
          </el-row>
          <el-row gutter="5">
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
            >
              <!-- v-if="form.promocion === '3ds'" -->
              <el-form-item label="Correo Electrónico" prop="ml">
                <el-input v-model="form.ml" />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
            >
              <!-- v-if="form.promocion === '3ds'" -->
              <el-form-item label="Celular" prop="cl">
                <el-input v-model="form.cl" maxlength="10" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <br>
        <el-row
          type="flex"
          justify="end"
          gutter="5"
        >
          <el-col :xs="24" :sm="6">
            <el-button
              type="primary"
              style="width: 100%"
              @click="submit"
            >
              Pagar
            </el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-main>
    <el-footer>
      <img
        src="../assets/images/instituciones-participantes-wpp.png"
        alt="instituciones-participantes-wpp.png"
      >
    </el-footer>
  </el-container>
</template>

<script>
import Moment from 'moment';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      form: {
        promocion: '3ds',
        // promocion: '3',
        // meses: 3,
        ml: null,
        cl: null,
      },
      paymentMethods: [
        {
          value: '3ds',
          label: 'Contado',
        },
      ],
      /*
      monthsOptions: [
        {
          value: 3,
          label: '3 meses',
        },
        {
          value: 6,
          label: '6 meses',
        },
      ],
      */
      rules: {
        cl: [
          {
            required: true,
            message: 'El campo es requerido',
          },
          {
            pattern: /^[0-9]{10}$/,
            message: 'Ingrese un número telefónico válido',
          },
        ],
        ml: [
          {
            required: true,
            message: 'El campo es requerido',
          },
          {
            type: 'email',
            message: 'Ingrese correo electrónico válido',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      cart: (state) => state.cart.data,
      user: (state) => state.predio.user,
      cargos: (state) => state.predio.data,
    }),
    debts() {
      const regExp = /impuesto|gastos|predial|notificacion/i;

      // console.log('cargos en debts ');
      // console.log(this.cargos);
      return this.cargos.filter(
        (x) => regExp.test(x?.observaciones) && x.checked
      );
    },
    /**
     * Busca y retorna el primer periodo
     * @readonly
     * @returns {Object}
     */
    firstPeriod() {
      const [item] = this.debts;
      const yearRegExp = /predial ([0-9]{4})/i;
      const yearMatch = yearRegExp.exec(item.observaciones);
      const year = Array.isArray(yearMatch) ? yearMatch[1] : 'N/A';
      const numRegExp = /(bim.|bimestre) ([0-9]{1})/i;
      const numMatch = numRegExp.exec(item.observaciones);
      const num = Array.isArray(numMatch) ? numMatch[2] : 'N/A';
      return {
        year,
        num,
      };
    },
    /**
     * Busca y retorna el último periodo
     * @readonly
     * @returns {Object}
     */
    lastPeriod() {
      const item = this.debts[this.debts.length - 1];
      const yearRegExp = /predial ([0-9]{4})/i;
      const yearMatch = yearRegExp.exec(item.observaciones);
      const year = Array.isArray(yearMatch) ? yearMatch[1] : 'N/A';
      const numRegExp = /(bim.|bimestre) ([0-9]{1})/i;
      const numMatch = numRegExp.exec(item.observaciones);
      const num = Array.isArray(numMatch) ? numMatch[2] : 'N/A';
      return {
        year,
        num,
      };
    },
  },
  methods: {
    beforeSubmit() {
      return new Promise((resolve) => {
        this.$refs.form.validate(resolve);
      });
    },
    async submit() {
      try {
        this.loading = true;
        const isValid = await this.beforeSubmit();

        if (isValid) {
          const values = { ...this.form };

          const { firstPeriod, lastPeriod } = this;

          values.referencia = this.cart.ref;
          console.log('cargos en santander');
          console.log(this.cart);
          console.log('referencia santander');
          console.log(this.cart.ref);

          // values.cargos = this.cart.cargos.splice(0, 5);
          values.cargos = this.cart.cargos;
          console.log('VALUES.CARGOS');
          console.log(values.cargos);

          values.predio = this.user.pk.toString();

          console.log('objetos cargos');
          console.log(this.cargos);

          console.log('PREDIO');
          console.log(this.predio);

          values.concepto = {
            nombre: 'Predial',
            valor: `${firstPeriod.year} Bim. ${firstPeriod.num} - ${lastPeriod.year} Bim. ${lastPeriod.num}`,
          };
          values.es3ds = values.promocion === '3ds';
          values.promocion = values.es3ds ? 'C' : values.promocion;
          if (!values.es3ds) {
            values.ml = null;
            values.cl = null;
          }
          values.promocion = values.promocion === 'meses'
            ? values.meses.toString()
            : values.promocion;
          values.monto = this.cart.total;
          delete values.meses;
          delete values.es3ds;
          const response = await this.axios.post('/WPP/ObtenerLiga', values);
          console.log(response);
          const { data } = response;
          const { tiene_seguro } = this.user;
          const { tiene_opd } = this.user;
          const { id_consulta } = this.user;
          const { cargos } = this.user;
          const padron_id = this.user.pk;
          const total = parseFloat(this.cart.total.toFixed(2));
          const total_redondeo = parseFloat(this.cart.extra.toFixed(2));
          const currentDate = new Moment();
          const currentYear = currentDate.format('YYYY');
          if (data?.success) {
            const { url } = data;
            const { referencia } = data;
            console.log(`en referencia id_consulta${referencia}`);
            console.log(`en id_predio ${padron_id}`);
            console.log(url);
            this.loading = false;
            this.$store.dispatch('predio/SET_DATA', []);
            this.$store.dispatch('predio/SET_USER', {});
            this.$store.dispatch('cart/CLEAR_DATA');
            const resGuardarRef = await this.axios.post(
              'https://indicadores.zapopan.gob.mx:8080/WSCajaWeb/api/referenciaWeb',
              {
                padron_id,
                total,
                redondeo: total_redondeo,
                idConsulta: id_consulta,
                anio: currentYear,
                bim: 6,
                canalDePago: 6,
                tieneSeguro: tiene_seguro,
                tieneOpd: tiene_opd,
                referencia,
                cargos,
              }
            );
            console.log(`en referencia id_consulta${id_consulta}`);
            console.log(resGuardarRef);
            if (resGuardarRef) window.location.href = url;
            else {
              this.$ErrorNotify({
                response: {
                  data: {
                    alerta: 'Error al procesar referencia',
                  },
                },
              });
              setTimeout(() => {
                this.$router.push({ path: '/estado-de-cuenta' });
              }, 2000);
            }
          } else {
            this.$ErrorNotify({
              response: {
                data: {
                  alerta: data.message,
                },
              },
            });
            setTimeout(() => {
              this.$router.push({ path: '/estado-de-cuenta' });
            }, 2000);
          }
        }
      } catch (err) {
        this.$ErrorNotify(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#pagar-container {
  .el-button {
    background-color: #884e93;
    &:hover {
      opacity: 0.9;
    }
  }

  .cart-wrapper {
    margin: 10px 0px;
    border: solid #f0f0f0;
    border-width: 1px;
    .cart-title {
      border-radius: 5px 5px 0px 0px !important;
      background-color: #333333;
      color: #ffffff;
      padding: 10px;
      .cart-title__inner {
        font-size: 14px;
        padding: 0px !important;
        margin: 0px !important;
      }
    }
    .custom-table {
      padding-left: 10px;
      padding-right: 10px;
      .custom-row {
        display: flex;
        flex-direction: row;
        padding-top: 10px;
        padding-bottom: 10px;
        overflow: hidden;
        text-transform: uppercase;
        border: solid;
        border-width: 0px;
        border-bottom-width: 1px;
        border-color: #f0f0f0;
        &:last-child {
          border-bottom-width: 0px !important;
          .custom-row__value {
            text-align: right;
          }
        }
        .custom-row__field {
          color: #606266;
          min-width: 120px;
          width: 100%;
        }
        .custom-row__value {
          color: #0a0a0a;
          min-width: 120px;
          width: 100%;
        }
      }
    }
  }

  .flex {
    display: flex;
    flex-direction: row;
  }

  @media screen and (max-width: 767px) {
    .cart-title {
      text-align: center;
    }
    .xs-display-block-childs {
      display: unset !important;
      // &:first-child {
      //   display: block;
      // }
    }
  }
}
</style>

<style lang="scss">
#pagar-container {
  min-height: calc(100vh - 100px);
  overflow-y: scroll;
  .el-radio {
    width: calc(100% / 3) !important;
    display: flex;
  }
  .el-radio,
  .el-radio__input,
  .el-radio__label {
    height: 18px !important;
  }
  .el-form-item__label {
    font-weight: bold !important;
  }
  .el-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 10px;
  }
  .el-footer {
    padding: 10px !important;
    max-width: 100%;
    height: auto !important;
    img {
      object-fit: cover;
      width: 100%;
    }
  }
}
</style>
